import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ENGINEERING_DEPARTMENT_OBSERVATION,
  HANDOVER_TYPE_HO3_ID,
  OPERATIONS_DEPARTMENT_OBSERVATION,
} from 'src/app/handover-constants';
import { HandoverHistoryObservationDialog } from 'src/app/interfaces/handover-observation';

@Component({
  selector: 'app-handover-history-observations-dialog',
  templateUrl: './handover-history-observations-dialog.component.html',
  styleUrls: ['./handover-history-observations-dialog.component.scss'],
  standalone: false,
})
export class HandoverHistoryObservationsDialogComponent {
  HO3 = HANDOVER_TYPE_HO3_ID;
  OPERATIONS_DO = OPERATIONS_DEPARTMENT_OBSERVATION;
  ENGINEERING_DO = ENGINEERING_DEPARTMENT_OBSERVATION;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<HandoverHistoryObservationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HandoverHistoryObservationDialog
  ) {
    this.matIconRegistry.addSvgIcon(
      'check-fill-green',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/check-fill-green.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'close-fill-red',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/close-fill-red.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'ho-pending.svg',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/ho-pending.svg'
      )
    );
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
